import axios from 'axios';
import { isDefined } from '../utilities';

const http = axios.create();

http.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

http.interceptors.response.use(response => {
    return response;
}, async (error) => await handleError(error));

const handleError = async (error) => {
    if (error.response) {
        if (error.response.status === 403) {
            window.location = '/403';
        } else if (error.response.status === 419 || error.response.status === 401) {
            window.location = '/';
        }
    }

    throw(error);
}

export const getError = (response) => {
    if (isDefined(response.data) && isDefined(response.data.errors)) {
        const errors = response.data.errors;

        if (Array.isArray(errors)) {
            return errors[0];
        }

        return errors;
    }

    return 'Something went wrong';
};

export const HttpService = {
    getDefaultHeaders() {
        return  {
            'content-type': 'application/json',
        };
    },

    async httpPost(url, data = {}, headers = {}, onUploadProgress = false, abortController = false) {
        headers = {...this.getDefaultHeaders(), ...headers};

        try {
            const config = {
                headers: headers
            };

            if (onUploadProgress) {
                config.onUploadProgress = onUploadProgress
            }

            if (abortController) {
                config.signal = abortController
            }

            const response = await http.post(url, data, config);

            if (response.data.hasOwnProperty('result')) {
                return response.data.result;
            }

            return response.data;
        } catch(error) {
            return this.formatError(error);
        }
    },

    async httpGet(url, params = {}, headers = {}) {
        headers = {...this.getDefaultHeaders(), ...headers};

        try {
            const response = await http.get(url, {headers: headers, params: params});

            if (response.data.result) {
                return response.data.result;
            }

            return response.data;
        } catch(error) {
            return this.formatError(error);
        }
    },

    formatError(error) {
        if (axios.isCancel(error)) {
            throw (error);
        } else {
            throw ({
                status: error.response?.status,
                data: error.response?.data
            });
        }
    }
};
